import { Link as RouterLink } from 'react-router-dom';
import { SvgIcon } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ResponsiveButton } from 'components/buttons';
import { Icons } from 'greener-ui-library';

export default function UnitControl() {
  const { t } = useTranslation();
  return (
    <ResponsiveButton
      data-testid="assets-navigation"
      color="inherit"
      component={RouterLink}
      to="/assets"
      breakpoint="sm"
      icon={() => (
        <SvgIcon sx={{ fontSize: 24 }}>
          <Icons.UnitControl strokeColor="white" strokeWidth={2} />
        </SvgIcon>
      )}
      style={{ fontSize: 12, whiteSpace: 'nowrap' }}
    >
      {`${t('navigation.unitControl')}`}
    </ResponsiveButton>
  );
}
